<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="900"
      :mask-closable="false"
      title="导入客户模组"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form class="simiot-nested-search-form" :form="searchForm" @submit="handleSearch">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="模组厂商">
              <a-select
                v-decorator="['module_producer_id']"
                allow-clear
                show-search
                option-filter-prop="children"
                placeholder="请选择"
                @change="handleProducerChange"
              >
                <a-select-option
                  v-for="opt in producerOptions"
                  :key="opt.id"
                  :value="opt.id"
                >
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="模组型号">
              <a-select
                v-decorator="['module_model_id']"
                allow-clear
                show-search
                option-filter-prop="children"
                placeholder="请先选择模组厂商"
              >
                <a-select-option
                  v-for="opt in modelOptions"
                  :key="opt.id"
                  :value="opt.id"
                >
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-space>
                <a-button type="primary" html-type="submit">搜索</a-button>
                <a-button @click="handleReset">刷新</a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        size="middle"
        :columns="tableColumns"
        :data-source="tableData"
        :loading="loading"
        :pagination="false"
        :scroll="{ y: 350 }"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        row-key="id"
      />

      <a-row class="count-tips">
        共 {{ tableData.length }} 条记录，已选中 {{ selectedRowKeys.length }} 条数据
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'
import { findImportableBaseModuleProducts } from '@/api/base_module_product'
import { importAgentsModuleProducts } from '@/api/agents_module_product'
import { formatFloat } from '@/utils/filter'

export default {
  name: 'ImportAgentsModuleProduct',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    agentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      searchForm: this.$form.createForm(this, { name: 'import_agents_module_product_search' }),
      loading: true,
      selectedRowKeys: [],
      query: {},
      submitting: false,
      producerOptions: [],
      modelOptions: [],
      tableColumns: [
        { title: '模组厂商', dataIndex: 'module_producer_name' },
        { title: '模组型号', dataIndex: 'module_model_name' },
        { title: '单价(元/片)', dataIndex: 'unit_price', customRender: formatFloat }
      ],
      tableData: []
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    findCommonTypeOptions('product_module_producer').then((res) => {
      if (res.code === 0) {
        this.producerOptions = res.data
      }
    })
    this.fetchData()
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    handleProducerChange(producerId) {
      this.searchForm.setFieldsValue({ module_model_id: undefined })
      this.modelOptions = []
      if (!producerId) return
      findCommonTypeOptions('product_module_model', undefined, producerId).then((res) => {
        if (res.code === 0) {
          this.modelOptions = res.data
        }
      })
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findImportableBaseModuleProducts(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        this.tableData = res.data || []
        this.loading = false
      })
    },

    handleSearch(e) {
      e.preventDefault()
      this.searchForm.validateFields((err, values) => {
        if (!err) {
          this.query = values
          this.fetchData()
        }
      })
    },

    handleReset() {
      this.searchForm.resetFields()
      this.modelOptions = []
      this.query = {}
      this.fetchData()
    },

    handleSubmit() {
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      if (this.selectedRowKeys.length === 0) {
        this.$warning({ title: '请选择操作对象', content: '' })
        return
      }

      this.submitting = true
      importAgentsModuleProducts({
        agent_id: this.agentId,
        base_module_product_ids: this.selectedRowKeys
      }).then((res) => {
        if (res.code === 0) {
          this.isShow = false
          this.$emit('completed')
        }
        this.submitting = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.count-tips {
  padding-top: 20px;
}
</style>
